module.exports = __webpack_public_path__ + "components/country-flag/static/bz-92809c32e0e8e56433ff285d1d4090ea.svg";